$(function() {
  $('.autosubmit').on('change', function(element) {
    if (
      element.target.hasAttribute('data-mode') &&
      element.target._flatpickr &&
      element.target._flatpickr.selectedDates &&
      element.target._flatpickr.selectedDates.length < 2
    ) {
      return
    }
    $(this).submit()
  })
})
